import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { SITE } from "../../config/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-neutral-900 text-white">
    <div className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-24">
      <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-display text-3xl font-bold tracking-tight">
            NXT<span className="text-coral">Plate</span>
          </p>
          <p className="mt-4 max-w-sm text-base leading-relaxed text-neutral-400">
            {SITE.slogan}. Track what you eat, see what you still need, and know what comes next.
          </p>
          <a
            href={`mailto:${SITE.supportEmail}`}
            data-testid="footer-email-link"
            className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-neutral-300 transition-colors duration-200 hover:text-coral"
          >
            <Mail className="h-4 w-4" aria-hidden="true" />
            {SITE.supportEmail}
          </a>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-neutral-500">Product</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link data-testid="footer-link-features" to="/#features" className="text-neutral-300 transition-colors duration-200 hover:text-white">What NXTPlate does</Link></li>
            <li><Link data-testid="footer-link-why" to="/#why" className="text-neutral-300 transition-colors duration-200 hover:text-white">Track less. Decide better.</Link></li>
            <li><Link data-testid="footer-link-plans" to="/#plans" className="text-neutral-300 transition-colors duration-200 hover:text-white">Plans</Link></li>
            <li><Link data-testid="footer-link-press" to="/press" className="text-neutral-300 transition-colors duration-200 hover:text-white">Press Kit</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-neutral-500">Help</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link data-testid="footer-link-support" to="/support" className="text-neutral-300 transition-colors duration-200 hover:text-white">Support</Link></li>
            <li><Link data-testid="footer-link-subscriptions" to="/support#subscriptions" className="text-neutral-300 transition-colors duration-200 hover:text-white">Subscriptions</Link></li>
            <li><Link data-testid="footer-link-delete-account" to="/support#account-deletion" className="text-neutral-300 transition-colors duration-200 hover:text-white">Delete account</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-neutral-500">Legal</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link data-testid="footer-link-privacy" to="/privacy" className="text-neutral-300 transition-colors duration-200 hover:text-white">Privacy Policy</Link></li>
            <li><Link data-testid="footer-link-terms" to="/terms" className="text-neutral-300 transition-colors duration-200 hover:text-white">Terms of Use</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-16 border-t border-white/10 pt-8">
        <p className="text-sm text-neutral-500">
          © {new Date().getFullYear()} {SITE.name} · {SITE.domain}
        </p>
        <p className="mt-3 max-w-2xl text-xs leading-relaxed text-neutral-500">
          {SITE.name} is a wellness and nutrition app. It does not provide medical advice, medical
          diagnosis, or treatment. Always consult a qualified healthcare professional before making
          significant changes to your diet.
        </p>
      </div>
    </div>
  </footer>
);
